import { useQuery } from "react-query";
import { getChannel } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveChannel = () => {
  return useQuery("Channel", getChannel, {
    refetchOnWindowFocus: false,
  });
};
